import { render, staticRenderFns } from "./group-dashboard-editor.vue?vue&type=template&id=f99966e6&"
import script from "./group-dashboard-editor.vue?vue&type=script&lang=js&"
export * from "./group-dashboard-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports